import { cart, drawers } from '@theme/core';

// Quick add on product cards. Delegated, so cards injected later (recommendations, search) work too.
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-quick-add]');
  if (!btn) return;
  e.preventDefault();
  const panel = btn.closest('[data-quick]');
  if (panel.classList.contains('is-busy')) return;
  const msg = panel.querySelector('[data-quick-msg]');
  panel.classList.add('is-busy');
  try {
    await cart.add(+btn.dataset.quickAdd, 1);
    msg.textContent = 'Added';
    drawers.open('cart-drawer');
  } catch (ex) {
    msg.textContent = ex.message;
  }
  panel.classList.add('is-done');
  setTimeout(() => panel.classList.remove('is-busy', 'is-done'), 1500);
});
